import { SubProject } from './sub-project';

export class BaseProject extends SubProject {
  includeRepoInPrice?: boolean;
  stockShortageOnCreate?: boolean;

  constructor(id?: number) {
    if (id != null) {
      super(id);
    } else {
      super();
    }

    this.type = 'BaseProject';
  }
}
